import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import {pushBookMap, mapInteractGA4} from '@helpers/gtm';
import Button from 'js/components/shared/Button'
import PriceBlock from 'js/components/PriceBlock';
import InfoBanner from 'js/components/shared/InfoBanner';
import StarsIco from '../../../shared/icons/StarsIco'
import {pushOpenDatesFilter, pushOpenRoomsFilter} from 'js/scenes/MainSearchBox/customEvents';

import styles from './HotelListCardMini.module.scss'

const priceHelperText = window?.drupalSettings?.searchResults?.priceHelperText ?? 'Member rate'
const priceOldHelperText = window?.drupalSettings?.searchResults?.priceOldHelperText ?? 'Public rate'

const CARD_AVAILABLE = 'available';
const CARD_UNACCOMODATED = 'unaccomodated';
const CARD_UNAVAILABLE = 'unavailable';
const CARD_LOADING = 'loading';

const cx = classnames.bind(styles)

const HotelListCardMini = function ({
  item: {
    reserveBtn,
    reserveBtnUnavailable,
    unavailableText,
    reserveBtnUrl,
    available,
    unaccomodated,
    price,
    priceColor,
    oldPrice,
    member,
    public: publicPrice,
    subPrice,
    discountTooltipText,
    stars,
    title,
    hotelLink,
    firstImage,
    isConnected,
    id,
  },
  loading,
  className,
}) {
  const cardStatus = useMemo(function () {
    if (unaccomodated)
      return CARD_UNACCOMODATED;

    if (loading)
      return CARD_LOADING;

    if (available)
      return CARD_AVAILABLE;

    return CARD_UNAVAILABLE;
  }, [unaccomodated, loading, available]);

  const reserveBtnHandler = (e) => {
    e.stopPropagation()

    switch (cardStatus) {
      case CARD_UNAVAILABLE:
        e.preventDefault();
        pushOpenDatesFilter();
        break;
      case CARD_UNACCOMODATED:
        e.preventDefault();
        pushOpenRoomsFilter();
        break;
    }
    pushBookMap()
    mapInteractGA4('hotel book')
  }

  return (
    <div
      className={cx('slide-item', className)}
      role="presentation"
      data-cs-hotelid={id}
    >
      <div className={cx('image-wrap')}>
        {firstImage && (<img {...firstImage} alt={firstImage.alt} loading="lazy" />)}
      </div>

      <div className={cx('content')}>
        <h2 className={cx('title')}>
          <a
            href={hotelLink}
            rel="noopener noreferrer"
            target="_blank"
            className={cx('title-link')}
          >
            {title}
            <StarsIco
              stars={stars}
              className={cx('title-stars')}
              data-stars-count={stars}
            />
          </a>
        </h2>
        {cardStatus === CARD_AVAILABLE && (
          <PriceBlock
            align="right"
            className={cx('price-block')}
            info={subPrice}
            shortVersion={isConnected}
            priceColor={priceColor}
            discountTooltipText={discountTooltipText}
            priceHelperText={priceHelperText}
            priceOldHelperText={priceOldHelperText}
            defaultPrice={{price, oldPrice}}
            memberPrice={member}
            publicPrice={publicPrice}
          />
        )}
        {cardStatus === CARD_UNAVAILABLE && unavailableText && (
          <InfoBanner color="blue" size="sm">
            {unavailableText}
          </InfoBanner>
        )}
        {cardStatus === CARD_UNACCOMODATED && unavailableText && (
          <InfoBanner color="blue" size="sm">
            {unavailableText}
          </InfoBanner>
        )}
        {reserveBtnUrl && (
          <Button
            tag="a"
            href={reserveBtnUrl}
            theme="squared"
            color={cardStatus === CARD_AVAILABLE ? 'black' : 'main'}
            className={cx('main-btn')}
            disabled={cardStatus === CARD_LOADING}
            onClick={reserveBtnHandler}
          >
            {cardStatus === CARD_AVAILABLE && reserveBtn}
            {cardStatus === CARD_UNAVAILABLE && reserveBtnUnavailable}
            {cardStatus === CARD_UNACCOMODATED && reserveBtnUnavailable}
            {cardStatus === CARD_LOADING && reserveBtn}
          </Button>
        )}
      </div>
    </div>
  )
}

HotelListCardMini.propTypes = {
  className: PropTypes.string,
  item: PropTypes.objectOf(Object).isRequired,
  onSelectSliderItem: PropTypes.func.isRequired,
}

export default HotelListCardMini
